import template from "./account-activity-request-reimbursement.html"

(function ($, ko) {
    ko.components.register('account-activity-request-reimbursement', {
        template: template,
        viewModel: {
            createViewModel: function (params, componentInfo) {
                return new AccountActivityRequestReimbursement(params, updateContainerHeight(componentInfo.element));
            }
        }
    });

    function AccountActivityRequestReimbursement(params, updateHeight) {
        const self = this;
        let model = params.model;
        let accountsList = params.accountsList;

        self.isMobile = params.isMobile || false;
        self.isDirectRequest = ko.observable(false);
        self.anyHsaOnly = ko.observable(false);
        self.anyNonHsaOnly = ko.observable(false);
        self.accountsList = ko.pureComputed(function () {
            return ko.unwrap(accountsList) || [];
        });
        self.isServiceStartDateWithinAnyActivePlan = ko.pureComputed(function () {
            if (!model.ServiceStartDate) {
                return false;
            }

            var serviceStartDate = moment.utc(model.ServiceStartDate);
            if (!serviceStartDate.isValid()) {
                return false;
            }

            return self.accountsList().some(function (account) {
                if (!account ||
                    !account.PlanStartDate ||
                    !account.LastDayToSubmitClaim) {
                    return false;
                }

                var planStartDate = moment.utc(account.PlanStartDate);
                var submitClaimsLastDate = moment.utc(account.LastDayToSubmitClaim);

                if (!planStartDate.isValid() || !submitClaimsLastDate.isValid()) {
                    return false;
                }

                return serviceStartDate.isSameOrAfter(planStartDate, 'day') &&
                    serviceStartDate.isSameOrBefore(submitClaimsLastDate, 'day');
            });
        });
        self.showRequestReimbursementButton = ko.pureComputed(function () {
            return self.isServiceStartDateWithinAnyActivePlan();
        });

        self.popupModel = {
            ItemId: model.ItemId,
            EOBExtra: {
                ExternalClaimId: model.ClaimId,
                ExpenseKeys: model.ExpenseKeys
            },
            EOBType: model.EOBType,
            OriginCde: model.OriginCde,
            ServiceStartDate: model.ServiceStartDate,
            ExpenseKey: model.ExpenseKey,
            Amount: model.Amount
        };
        
        self.isEnabledPortal = $.cdh.tpa.useExpensePortal;
        self.goToPortal = () => {
            let portalParam = '';
            if (model.IsFxClaim) {
                portalParam = `fxClaimId=${model.ClaimId}`;
            } else if (model.IsTcClaim) {
                portalParam = `tcClaimId=${model.ClaimId}`;
            } else if (model.IsExpense) {
                portalParam = `expenseKey=${model.ExpenseKey}&originCde=${model.OriginCde}`;
            }

            document.location.href = $.cdh.routes.predefined.claims.portal + '?' + portalParam;
        };

        if(params.accountsLoaded()) {
            setBuilder();
        } else {
            params.accountsLoaded.subscribe(setBuilder);
        }
        
        function setBuilder() {
            setAccountsInfo();
            
            if (model.IsFxClaim) {
                self.builder = function () {
                    return new $.cdh.models.SubmitClaimWidgetModel(params.reloadListCallback, $.noop, self.popupModel);
                };
                self.template = function () {
                    return 'template-claim-widget-view';
                };

            } else if (!self.isDirectRequest()) {
                self.builder = function () {
                    return new $.cdh.models.RequestReimbursementType(params.reloadListCallback, $.noop, self.popupModel, true);
                };
                self.template = function () {
                    return 'template-claims-request-reimbursement-type';
                };

            } else {
                if (self.anyHsaOnly()) {
                    self.builder = function () {
                        return new $.cdh.models.PaymentsAddPopup(0, params.reloadListCallback, self.popupModel, $.noop, true);
                    };
                    self.template = function () {
                        return 'template-payments-add-popup';
                    };
                } else if (self.anyNonHsaOnly()) {
                    self.builder = function () {
                        return new $.cdh.models.SubmitClaimWidgetModel(params.reloadListCallback, $.noop, self.popupModel);
                    };
                    self.template = function () {
                        return 'template-claim-widget-view';
                    };
                }
            }
        }

        function setAccountsInfo() {
            let anyHsaCurrent = $.cdh.accounts.anyHsaCurrent();
            let anyHsaPrevious = $.cdh.accounts.anyHsaPrevious();
            let anyNonHsaCurrent = $.cdh.accounts.anyNonHsaCurrent();
            let anyNonHsaPrevious = $.cdh.accounts.anyNonHsaPrevious();
            let hsaOnly = anyHsaCurrent || anyHsaPrevious;
            let nonHsaOnly = anyNonHsaCurrent || anyNonHsaPrevious;

            self.anyHsaOnly(hsaOnly && !nonHsaOnly);
            self.anyNonHsaOnly(!hsaOnly && nonHsaOnly);
            self.isDirectRequest(self.anyHsaOnly() || self.anyNonHsaOnly());
        }
        
        setBuilder();
    }

})(jQuery, ko);